<template>
  <div class="panel-body">
    <v-card>
      <v-card-title>Funds to Add</v-card-title>
      <v-row>
        <v-col cols="2">
          <v-text-field
            v-model="transaction.amount"
            class="onlyDigitInput"
            label="Amount"
            type="number"
            :rules="[availableAmount, amountFormat]"
            pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
            required
            prefix="$"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-select v-model="transaction.category" :items="categories" label="Category" required></v-select>
        </v-col>
        <v-col cols="5">
          <v-text-field
            v-model="transaction.description"
            label="Description"
            required
            :rules="[max255chars]"
            :counter="255"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
        <v-select v-model="transaction.sourceAccount" :items="dropdownOptions" label="Category"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox v-model="includeNotification" label="Include Notification"></v-checkbox>
          <v-btn
            :disabled="(includeNotification && (!this.$refs.notificationToSend || this.$refs.notificationToSend.$v.$invalid)) || !transaction.category || !transaction.amount"
            @click="addFunds"
          >Add Funds</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-if="includeNotification">
      <v-card-title>Notification</v-card-title>
      <v-row>
        <v-col>
          <notification
            ref="notificationToSend"
            :users="[user]"
            :broadcastVisible="false"
            :submitVisible="false"
            :sendConfirmation="false"
          ></notification>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import notification from '@/components/Notifications.vue'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    jar: {
      required: true
    },
    user: {
      required: true
    }
  },
  data: () => ({
    dialog: false,
    includeNotification: false,
    categories: ['Prize', 'Reward'],
    notificationToSend: null,
    direction: 'top',
    max2chars: v => (v && v.length <= 2) || 'Input too long!',
    max255chars: v => !v || v.length <= 255 || 'Input too long!',
    max512chars: v => (v && v.length <= 512) || 'Input too long!',
    maxamount: v => v <= this.availableAmount() || 'Amount will over fill jar',
    displayTitle: '',
    valid: true,
    dropdownOptions: [
      'quber',
      'quber-nsf-repay',
      'levis'
    ],
    transaction: {
      owner: null,
      accountName: null,
      description: null,
      category: null,
      date: new Date().toJSON(),
      transactionDate: new Date().toJSON(),
      amount: null,
      sourceAccount: '',
      transferStatus: 'received'
    }
  }),

  created () {
    this.initialize()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.setOwner(newValue.userId)
      }
    },
    jar: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.setAccountName(newValue.id)
      }
    }
  },
  components: {
    notification
  },
  computed: {},
  methods: {
    amountFormat (value) {
      if (!value || value.match('^[0-9]+(.[0-9]{1,2})?$')) return true
      else return 'Amount format invalid'
    },
    availableAmount (value) {
      if (
        !value ||
        value <= this.jar.goal - this.jar.received
      ) {
        return true
      } else {
        return (
          'Limit is $' + (this.jar.goal - this.jar.received)
        )
      }
    },
    initialize () {
      this.transaction = {
        owner: null,
        accountName: null,
        description: null,
        category: null,
        date: new Date().toJSON(),
        transactionDate: new Date().toJSON(),
        amount: null,
        sourceAccount: 'quber',
        transferStatus: 'received'
      }
      if (this.$refs.notificationToSend) this.$refs.notificationToSend.clear()
      this.includeNotification = false
    },
    close () {
      this.initialize()
      this.$emit('close-add-funds')
    },
    setOwner (newUser) {
      this.transaction.owner = newUser
    },
    setAccountName (newJar) {
      this.transaction.accountName = 'jar-' + newJar
    },
    async addFunds () {
      if (!this.user || !this.user.userId) {
        alert('Something went wrong, the user is not set')
        return
      }
      if (!this.jar || !this.jar.id) {
        alert('Something went wrong, the jar is not set')
        return
      }
      this.setOwner(this.user.userId)
      this.setAccountName(this.jar.id)
      const endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ACCOUNT
      }/transactions?createAccount=true`
      var postResponse = await rh.default
        .post(endpoint, this.transaction, true)
        .catch(e => {
          this.errors.push(e)
        })
      if (
        this.includeNotification &&
        this.$refs.notificationToSend &&
        !this.$refs.notificationToSend.$v.$invalid
      ) {
        this.$refs.notificationToSend.submit()
        this.includeNotification = false
      }
      this.initialize()
      this.$emit('save-add-funds')
    }
  }
}
</script>
<style>
.onlyDigitInput input[type="number"] {
  -moz-appearance: textfield;
}
.onlyDigitInput input::-webkit-outer-spin-button,
.onlyDigitInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
